"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var Default_1 = require("./Default");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return Default_1.default; } });



//////////////////
// WEBPACK FOOTER
// ./node_modules/avataaars/dist/avatar/face/nose/index.js
// module id = 293
// module chunks = 0